import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';

import { clearFiltersIfEmpty, selectAvailability } from '../store/actions/query';
import { delayRetrieveRecords } from '../store/actions/search';

export class AvailabilitiesFilter extends React.Component {
  static propTypes = {
    availabilities: PropTypes.array.isRequired,
    clearFiltersIfEmpty: PropTypes.func.isRequired,
    delayRetrieveRecords: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  handleAvailabilityChange = (e) => {
    const { clearFiltersIfEmpty, delayRetrieveRecords, onSelect } = this.props;
    onSelect(e.target.value, e.target.checked);
    clearFiltersIfEmpty();
    delayRetrieveRecords();
  };

  render() {
    const { availabilities, selected } = this.props;

    return (
      <FilterCheckboxGroup
        defaultKey="mobile"
        options={availabilities}
        selected={selected}
        onChange={this.handleAvailabilityChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  selected: state.query.availabilities
});

const mapDispatchToProps = {
  clearFiltersIfEmpty,
  delayRetrieveRecords,
  onSelect: selectAvailability
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilitiesFilter);
